<template>
  <v-layout>
    <v-flex>
      <v-text-field
        v-model="minPrice"
        clearable
        @keyup.enter="getSimilarItems"
        label="Precio mínimo"
        prepend-icon="arrow_downward"
        :rules="[mustBeNumber]"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "matching"
);

export default {
  computed: {
    ...mapState(["similarItemsFilters"]),
    minPrice: {
      get() {
        return this.similarItemsFilters.minPrice;
      },
      set(price) {
        price = Number(price);
        if (price && !Number.isNaN(price)) {
          this.setSimilarItemsFiltersMinPrice(Number(price));
        } else {
          this.setSimilarItemsFiltersMinPrice(null);
        }
      }
    }
  },
  methods: {
    ...mapActions(["getSimilarItems"]),
    ...mapMutations(["setSimilarItemsFiltersMinPrice"]),
    mustBeNumber(value) {
      return !Number.isNaN(Number(value)) || "El precio debe ser un número";
    }
  }
};
</script>
